// Supabase Client Configuration
// Uses anon key for client-side operations (safe with RLS policies)

// Note: For production, these should be in environment variables
const SUPABASE_URL = 'https://eximyshafkuyehkiotuf.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImV4aW15c2hhZmt1eWVoa2lvdHVmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTUxODc0MDEsImV4cCI6MjA3MDc2MzQwMX0.bjrI5MO_WUfnI53UaQ_m8BS8LPh2et5OrqMKmWUvYzw';

// Since @supabase/supabase-js might not be installed, we'll use fetch API directly
// This is a lightweight approach that doesn't require additional dependencies

class SupabaseClient {
  constructor(url, anonKey) {
    this.url = url;
    this.anonKey = anonKey;
  }

  async query(table, options = {}) {
    const { filters = {}, order_by = null, order_direction = 'asc', limit = 1000, offset = 0 } = options;
    
    let queryUrl = `${this.url}/rest/v1/${table}?`;
    
    // Add select parameter
    queryUrl += 'select=*';
    
    // Add ordering
    if (order_by) {
      queryUrl += `&order=${order_by}.${order_direction}`;
    }
    
    // Add limit and offset
    queryUrl += `&limit=${limit}&offset=${offset}`;
    
    try {
      const response = await fetch(queryUrl, {
        method: 'GET',
        headers: {
          'apikey': this.anonKey,
          'Authorization': `Bearer ${this.anonKey}`,
          'Content-Type': 'application/json',
          'Prefer': 'return=representation'
        }
      });

      if (!response.ok) {
        throw new Error(`Supabase query failed: ${response.status} ${response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Supabase query error:', error);
      throw error;
    }
  }

  async getAll(table) {
    return this.query(table, { limit: 1000 });
  }
}

// Create singleton instance
const supabaseClient = new SupabaseClient(SUPABASE_URL, SUPABASE_ANON_KEY);

export default supabaseClient;

